<template>
  <transition
    enter-active-class="transition duration-500 ease-out"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition duration-300 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div v-if="showBanner" class="fixed bottom-0 left-0 right-0 z-[100] bg-slate-900 text-white p-4 shadow-2xl border-t border-slate-800">
      <div class="container max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center shrink-0">
            <component :is="CookieIcon" class="w-5 h-5 text-red-500" />
          </div>
          <p class="text-xs sm:text-sm text-slate-300 leading-relaxed max-w-3xl">
            We use cookies to enhance your browsing experience and analyze our traffic. 
            By clicking "Accept All", you consent to our use of cookies. 
            Read our <NuxtLink to="/privacy" class="text-red-400 hover:text-red-300 underline">Privacy Policy</NuxtLink>.
          </p>
        </div>
        <div class="flex items-center gap-3 shrink-0 w-full sm:w-auto">
          <button @click="decline" class="flex-1 sm:flex-none px-6 py-2.5 rounded-lg text-xs font-bold text-slate-300 hover:bg-slate-800 transition-colors uppercase tracking-widest">
            Decline
          </button>
          <button @click="accept" class="flex-1 sm:flex-none px-6 py-2.5 rounded-lg bg-red-600 hover:bg-red-700 text-white text-xs font-bold transition-all shadow-lg shadow-red-600/20 uppercase tracking-widest">
            Accept All
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useTrackingStore } from '~/stores/tracking'
import { Cookie as CookieIcon } from 'lucide-vue-next'

const trackingStore = useTrackingStore()
const showBanner = ref(false)

onMounted(() => {
  if (process.client) {
    const consent = localStorage.getItem('tracking_consent')
    if (consent === null) {
      showBanner.value = true
    }
  }
})

const accept = () => {
  trackingStore.grantConsent()
  showBanner.value = false
}

const decline = () => {
  trackingStore.revokeConsent()
  if (process.client) {
    localStorage.setItem('tracking_consent', 'declined')
  }
  showBanner.value = false
}
</script>
